<template>
  <Slideover :visible="visible">
    <div>
      <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
        <div class="flex items-start justify-between space-x-3">
          <h2 class="text-lg leading-7 font-medium">
            {{ title }}
          </h2>
          <div class="h-7 flex items-center">
            <button
              type="button"
              aria-label="Close panel"
              @click="closeSlideover"
              class="text-green-300 hover:text-white transition ease-in-out duration-150"
            >
              <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <div class="py-4 px-4 space-y-2">
        <div class="flex items-center space-x-2">
          <input
            type="checkbox"
            id="ccpa_option"
            class="form-checkbox h-4 w-4 text-green-600"
            v-model="options.ccpa"
          />
          <label for="ccpa_option">
            CCPA
          </label>
        </div>
        <div class="flex items-center space-x-2">
          <input
            type="checkbox"
            id="mail_option"
            class="form-checkbox h-4 w-4 text-green-600 disabled:text-gray-300"
            v-model="options.mail"
            :disabled="options.ccpa"
          />
          <label for="mail_option">
            Mail
          </label>
        </div>
        <div class="flex items-center space-x-2">
          <input
            type="checkbox"
            id="call_option"
            class="form-checkbox h-4 w-4 text-green-600 disabled:text-gray-300 disabled:border-red-500"
            v-model="options.call"
            :disabled="options.ccpa"
          />
          <label for="call_option">
            Call
          </label>
        </div>
      </div>

      <div class="flex w-full justify-center">
        <span v-if="error" class="text-red-500">Something went wrong!</span>
      </div>
      <div class="flex w-full justify-center">
        <Button
          @click-handler="updateUnsubscribeOptions"
          :disabled="processing"
          class="flex items-center space-x-2"
        >
          <LoadingSpinner v-if="processing" />
          <span>Update</span>
        </Button>
      </div>
    </div>
  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Customer = ApiFactory.get('customers');

export default {
  name: "CustomerUnsubscribeOptions",
  components: {
    Button,
    Slideover,
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object
    }
  },
  data() {
    return {
      processing: false,
      error: false,
      original: this.defaultOptions(),
      options: this.defaultOptions(),
    }
  },
  computed: {
    changed() {
      let dirty = {};

      for (let option in this.original) {
        if (this.options[option] != this.original[option]) {
          dirty[option] = this.options[option];
        }
      }

      return dirty;
    }
  },
  watch: {
    customer(value) {
      if (! value.CustomerID) {
        return;
      }
      
      this.loadUnsubscribeOptions();
    },
    options: {
      handler(value) {
        if (! value.ccpa) {
          return;
        }

        value.mail = true;
        value.call = true;
      },
      deep: true
    }
  },
  methods: {
    loadUnsubscribeOptions() {
      Customer.getUnsubscribe(this.customer.CustomerID)
        .then((response) => {
          this.updateLocalData(response.data?.body);
        });
    },
    updateLocalData(data) {
      this.original = {
        ccpa: Boolean(data?.ccpa),
        mail: Boolean(data?.mail),
        call: Boolean(data?.call),
      };
      this.options = {...this.original};
    },
    updateUnsubscribeOptions() {
      this.error = false;
      this.processing = true;
      Customer.patchUnsubscribe(this.customer.CustomerID, this.options)
        .then((response) => {
          this.$emit('toggle-slideover');
          this.updateLocalData(response.data?.body);
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.processing = false;
        });
    },
    defaultOptions() {
      return {
        ccpa: false,
        mail: false,
        call: false,
      }
    },
    closeSlideover() {
      this.options = {...this.original};
      this.$emit('toggle-slideover');
    }
  }

};
</script>
